import DashboardUnreadsRenderer from "./dashboard_unreads_renderer";
import DashboardSavedRenderer from "./dashboard_saved_renderer";

function handleSearch() {
  const ownersValue = $("#search-input-owners").val().toLowerCase();
  const mentionsValue = $("#search-input-mentions").val().toLowerCase();

  $(".unread-admin-comment-group").map(function (_e) {
    if (hasOwnerEntries(this, ownersValue) && hasMentionEntries(this, mentionsValue)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

function hasMentionEntries(element, value) {
  return $(element)
    .find(".regular-notification .atwho-custom")
    .text()
    .toLowerCase()
    .includes(value);
}

function hasOwnerEntries(element, value) {
  return $(element).find(".owner-link").text().toLowerCase().includes(value);
}

function refreshMessages() {
  if ($("body.admin_dashboard").length) {
    $.ajax({
      url: "/admin/dashboard/unread",
      success: (response) => {
        const unreadsRenderer = new DashboardUnreadsRenderer();
        unreadsRenderer.refresh(response.data);
        unreadsRenderer.refreshCounter(response.length);
      },
    });
    $.ajax({
      url: "/admin/dashboard/saved",
      success: (response) => {
        const savedRenderer = new DashboardSavedRenderer();
        savedRenderer.refresh(response.data);
        savedRenderer.refreshCounter(response.length);
      },
    });
  }
}

function initTabs() {
  $("#dashboardTab a").click(function (e) {
    e.preventDefault();
    $(this).tab("show");
  });
}

$(document)
  .on("turbolinks:before-cache", () => $("#unread-comments-container").empty())
  .on("turbolinks:load", refreshMessages)
  .on("turbolinks:load", initTabs)
  .on("visibilitychange", refreshMessages);

$(document)
  .on("input", "#search-input-owners", handleSearch)
  .on("input", "#search-input-mentions", handleSearch);

$(document).on("ajax:success", ".admin_dashboard a.save-message", (e) => {
  $(e.target).toggleClass("saved");
});

$(document).on("ajax:success", ".admin_dashboard a.refresh", refreshMessages);

$(document).on("click", ".admin_dashboard .toggle-collapse", (e) => {
  let shipmentBlock = $(e.target).parents(".dashboard-messages-group");
  let shipmentId = shipmentBlock.data("shipmentId");
  console.log("clickety", shipmentId);
  window.collapsedState[shipmentId] = !window.collapsedState[shipmentId];
  shipmentBlock.toggleClass("collapsed");
});
